import { DetailedHTMLProps, InputHTMLAttributes } from 'react';

import { FormInput, Icon } from 'src/components';

import styles from './FormOrderInput.module.scss';


type TFormOrderInput = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
	className?: string;
	isLoading?: boolean;

	maxValue: number;
	value: string;
	setValue: (value: string) => void;
	addToCart: () => void;
};

export function FormOrderInput(props: TFormOrderInput) {
	const {
		maxValue,
		value,
		setValue,
		isLoading,
		addToCart,

		// className: classNameOuter = '',
	} = props;

	const decrease = (valueString: string) => {
		const amount = parseInt(valueString);
		const value = amount - 1;
		const validValue = Math.max(value, 1);

		setValue(validValue.toString());
	};

	const increase = (valueString: string) => {
		const amount = parseInt(valueString);
		const value = amount + 1;
		const validValue = Math.min(value, maxValue);

		setValue(validValue.toString());
	};

	const onChange = (valueString: string) => {
		const amount = parseInt(valueString);
		const validMinValue = Math.max(amount, 1);
		const value = Math.min(validMinValue, maxValue);

		setValue(value.toString());
	};

	const classNamesBox = [styles.box];
	if (isLoading) {
		classNamesBox.push(styles.loading);
	}

	const classNames = [styles.iconWrap, styles.iconWrapOrder];

	const classNamesWrapLeft = [styles.iconWrap, styles.borderRight];
	if (parseInt(value) <= 1) {
		classNamesWrapLeft.push(styles.iconDisabled);
	}

	const classNamesWrapRight = [styles.iconWrap, styles.borderLeft];
	if (parseInt(value) >= maxValue) {
		classNamesWrapRight.push(styles.iconDisabled);
	}

	return (
		<div className={ classNamesBox.join(' ') }>
			<div
				className={ classNamesWrapLeft.join(' ') }
				onClick={ e => decrease(value) }
			>
				<Icon className={ styles.icon } icon="icon-minus" />
			</div>

			<FormInput
				className={ styles.input }
				type="number"
				placeholder="0"
				min="1"
				name="amount"
				title="Укажите количество для добавления в заказ"
				value={ value }
				onChange={ e => onChange(e.target.value) }
				disabled={ isLoading }
				autoComplete="Off"
			/>

			<div
				className={ classNamesWrapRight.join(' ') }
				onClick={ e => increase(value) }
			>
				<Icon className={ styles.icon } icon="icon-plus" />
			</div>

			<div
				className={ classNames.join(' ') }
				onClick={ e => addToCart() }
			>
				<Icon className={ styles.icon } icon="icon-checkmark" />
			</div>
		</div>
	);
}
